import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import i18n from "i18next";
import { ShopOrdersDataGrid } from "src/components/views/erp/production/shopOrder/ShopOrdersDataGrid.tsx";
import { ShopOrderOperationsDataGrid } from "src/components/views/erp/production/shopOrderOperation/ShopOrderOperationsDataGrid.tsx";
import { CenteredTypography } from "src/components/common/CenteredTypography.tsx";
import { useState } from "react";
import { ShopOrderBomDataGrid } from "src/components/views/erp/production/shopOrderBom/ShopOrderBomDataGrid.tsx";
import { ShopOrderView } from "src/api/generated/erp/db/types/tables/shopOrderView.ts";
import { ShopOrderSource } from "src/api/generated/erp/production/shopOrderSource.ts";
import { SingleSourceTasksView } from "src/components/views/tasks/pages/SingleSourceTasksView.tsx";
import { useRefreshRef } from "src/utils/useRefreshRef.ts";
import { useTasksEnabled } from "src/components/views/tasks/useTasksEnabled.ts";

export interface ShopOrdersViewProps {
	onlyShopOrderId?: number;
	shopOrderSource?: ShopOrderSource;
	isActive?: boolean;
}

export const ShopOrdersView = ({ onlyShopOrderId, shopOrderSource }: ShopOrdersViewProps) => {
	const [selectedShopOrder, setSelectedShopOrder] = useState<ShopOrderView | undefined>(undefined);
	const tasksViewRefreshRef = useRefreshRef();
	const tasksEnabled = useTasksEnabled();

	return (
		<AavoMosaic
			viewId={"84087C040325F3AC"}
			layout={{
				type: "column",
				first: {
					type: "panel",
					content: (
						<ShopOrdersDataGrid
							onlyShopOrderId={onlyShopOrderId}
							shopOrderSource={shopOrderSource}
							onSelectionChanged={(selectedRows) => setSelectedShopOrder(selectedRows[0])}
						/>
					),
				},
				second: {
					type: "tabs",
					items: [
						{
							type: "panel",
							title: i18n.t("operations"),
							content:
								selectedShopOrder == null ?
									<CenteredTypography>{i18n.t("select_shop_order")}</CenteredTypography>
								:	<ShopOrderOperationsDataGrid
										key={selectedShopOrder.shopOrderId}
										shopOrderId={selectedShopOrder.shopOrderId}
									/>,
						},
						{
							type: "panel",
							title: i18n.t("bom"),
							content:
								selectedShopOrder == null ?
									<CenteredTypography>{i18n.t("select_shop_order")}</CenteredTypography>
								:	<ShopOrderBomDataGrid
										key={selectedShopOrder.shopOrderId}
										shopOrderId={selectedShopOrder.shopOrderId}
									/>,
						},
						tasksEnabled && {
							type: "panel",
							title: i18n.t("tasks"),
							content:
								selectedShopOrder == null ?
									<CenteredTypography>{i18n.t("select_shop_order")}</CenteredTypography>
								:	<SingleSourceTasksView
										key={selectedShopOrder.shopOrderId}
										taskSourceRef={{
											sourceType: "SHOP_ORDER",
											sourceId: selectedShopOrder.shopOrderId,
										}}
										refreshRef={tasksViewRefreshRef}
									/>,
						},
					],
				},
			}}
		/>
	);
};
